// extracted by mini-css-extract-plugin
module.exports = {"Title":"Welcome_Title__eN2Np","privacyLink":"Welcome_privacyLink__225IG"};